import { widgetWrapper } from './wrapper/WidgetWrapper.ts'
import { translateService } from './service/TranslateService.ts'
import { installService } from './service/InstallService.ts'
import {getCurrentLang} from "./utils.ts";

window.addEventListener('DOMContentLoaded', async () => {

	const container = document.querySelector('#google-translate')
	const metaParams = container.querySelector('[data-google-translate-params]')
	const params = JSON.parse(metaParams.getAttribute('data-google-translate-params'))

	installService.setParams(params)
	translateService.setParams(params)
	widgetWrapper
		.setContainer(container)
		.setParams(params)
		.render()
		.addListeners()

	const currentLang = getCurrentLang()
	if (currentLang) translateService.autoTranslate(500, currentLang)
})
